"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTokenVerifyRequest = instanceOfTokenVerifyRequest;
exports.TokenVerifyRequestFromJSON = TokenVerifyRequestFromJSON;
exports.TokenVerifyRequestFromJSONTyped = TokenVerifyRequestFromJSONTyped;
exports.TokenVerifyRequestToJSON = TokenVerifyRequestToJSON;
exports.TokenVerifyRequestToJSONTyped = TokenVerifyRequestToJSONTyped;
/**
 * Check if a given object implements the TokenVerifyRequest interface.
 */
function instanceOfTokenVerifyRequest(value) {
    if (!('token' in value) || value['token'] === undefined)
        return false;
    return true;
}
function TokenVerifyRequestFromJSON(json) {
    return TokenVerifyRequestFromJSONTyped(json, false);
}
function TokenVerifyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'],
    };
}
function TokenVerifyRequestToJSON(json) {
    return TokenVerifyRequestToJSONTyped(json, false);
}
function TokenVerifyRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'token': value['token'],
    };
}
//# sourceMappingURL=tokenVerifyRequest.js.map